import * as React from 'react';
import { RouteComponentProps, Redirect } from 'react-router';
import { Button, Container, Row, Col } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { QuestionnaireInfo } from 'models/Questionnaire';
import QuestionnaireService from 'services/QuestionnaireService';
import { LinkContainer } from 'react-router-bootstrap';
import l10n, { LanguageCode } from 'localization/LocalizationData';
import { MainLayout } from 'components/layouts/MainLayout';
import { LoadingView } from '../views/LoadingView';
import { CheckQueryParamSettings, GetQueryCulture } from 'Utilities/QueryParamSettings';

export const QuestionnaireListPage = (props: RouteComponentProps<{}>) => {
	const [list, setList] = useState<QuestionnaireInfo[]>([]);
	const [loading, setLoading] = useState<boolean>(true);

	if (CheckQueryParamSettings(props.location.search)) {
		const queryCulture = GetQueryCulture();
		if (queryCulture) {
			l10n.setLanguage(queryCulture);
		}
	}
	const state = props.location.state as any;
	const from: string | undefined = typeof state === 'object' ? state.from as string : undefined;

	useEffect(() => {
		setLoading(true);
		const request = async () => {
			try {
				const list = await QuestionnaireService.getList(l10n.getLanguage() as LanguageCode);
				setList(list);
			}
			catch (reason) {
				console.log(reason);
			}
			setLoading(false);
		}

		request();
	}, []);

	function onRetry() {
		setLoading(true);
		const request = async () => {
			try {
				const list = await QuestionnaireService.getList(l10n.getLanguage() as LanguageCode);
				setList(list);
			}
			catch (reason) {
				console.log(reason);
			}
			setLoading(false);
		}

		request();
	}

	if (loading) {
		return (
			<MainLayout>
				<LoadingView title={l10n.loading} />
			</MainLayout>
		)
	}

	if (list.length === 1) {
		return <Redirect to={from === 'start' ? '/' : `/questionnaire/${list[0].id}`} />
	} else if (list.length > 0) {
		return (
			<MainLayout>
				<Container className='align-items-center content mt-4'>
					<h1 className='mb-4 text-center'>{l10n.questionnaireList_choose_title}</h1>						
					{
						list.map((info, index) => {
							return <Row className='mb-3 justify-content-center'
								key={`form:${info.id}${index}`}>
								<Col xs={12} lg={6} >
									<LinkContainer to={`/questionnaire/${info.id}`}>
										<Button className='questionnaire-list-button'>
											{info.name}
										</Button>
									</LinkContainer>
								</Col>
							</Row>
						})
					}
				</Container>
			</MainLayout>
		);
	}



	return <MainLayout header={
		<LinkContainer to='/'>
			<Button>{l10n.button_toHome}</Button>
		</LinkContainer>
	}>
		<Container>
			<Row className='justify-content-center mb-4 mt-4'><h2>{l10n.error_generic}</h2></Row>
			<Row className='justify-content-center'><Col xs='auto'><Button onClick={() => onRetry()}>{l10n.button_tryAgain}</Button></Col></Row>
		</Container>
	</MainLayout>
}

export default QuestionnaireListPage;